// src/Pages/Home.js
import React from 'react';

const Login = () => {
  return <div>Welcome to Home Page</div>;
};

export default Login;
